import { computed, onMounted, onUnmounted, ref } from 'vue';

export const screens = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
};

const useBreakpoints = () => {
  const screenWidth = ref<number>(window.innerWidth);
  const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  const isMobile = computed(() => screenWidth.value < screens.sm);
  const isTablet = computed(
    () => screenWidth.value >= screens.md && screenWidth.value < screens.lg,
  );
  const isDesktop = computed(() => screenWidth.value >= screens.lg);

  const lt = {
    sm: computed(() => screenWidth.value < screens.sm),
    md: computed(() => screenWidth.value < screens.md),
    lg: computed(() => screenWidth.value < screens.lg),
    xl: computed(() => screenWidth.value < screens.xl),
    xxl: computed(() => screenWidth.value < screens.xxl),
  };
  const gt = {
    sm: computed(() => screenWidth.value > screens.sm),
    md: computed(() => screenWidth.value > screens.md),
    lg: computed(() => screenWidth.value > screens.lg),
    xl: computed(() => screenWidth.value > screens.xl),
    xxl: computed(() => screenWidth.value > screens.xxl),
  };

  return {
    isMobile,
    isDesktop,
    isTablet,
    lt,
    gt,
  };
};

export default useBreakpoints;
